<template>
    <div>
        <div class="container-fluid">
            <!-- Head -->
            <div class="d-flex align-items-center justify-content-between pt-4 mb-4">
                <div class="d-block">
                    <div class="h1-lg display-tektur m-0">Jurusan Kaka Kelas</div>
                </div>
                <div class="d-block">
                    <button v-if="tabActive == 'tab_rapor'" type="button" v-on:click="$parent.$parent.passing_grade_alumni_form();" class="btn btn-primary btn-lg btn-s-1">
                        <div class="btn-s-1-inner"><i class="fa-solid fa-circle-plus fa-lg me-3"></i>Tambah Data</div>
                    </button>
                    <button v-if="tabActive == 'tab_utbk'" type="button" v-on:click="$parent.$parent.passing_grade_alumni_utbk_form();" class="btn btn-primary btn-lg btn-s-1">
                        <div class="btn-s-1-inner"><i class="fa-solid fa-circle-plus fa-lg me-3"></i>Tambah Data</div>
                    </button>
                    <button type="button" v-on:click="goToPage('alumni')" class="btn btn-primary btn-lg btn-s-1" style="margin-left: 10px;">
                        <div class="btn-s-1-inner"><i class="fa-solid fa-file-import fa-lg me-3"></i>Import Data</div>
                    </button>
                </div>
            </div>
            <div class="d-block">
                <ul class="nav nav-tabs border-0">
                    <li class="nav-item">
                        <a class="nav-link" :class="tabActive == 'tab_rapor' ? 'active':''" href="javascript:void(0)" id="tab_rapor" v-on:click="changeTab('tab_rapor')">PM Rapor Alumni</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="tabActive == 'tab_utbk' ? 'active':''" href="javascript:void(0)" id="tab_utbk" v-on:click="changeTab('tab_utbk')">PM UTBK</a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Data -->
        <div class="card rounded-0 m-0 bg-card-trans-3">
            <div class="card-header">
                <div class="input-group input-group-flush input-group-merge input-group-reverse">
                    <input class="form-control list-search" type="search" placeholder="Cari data disini..." v-model="keywords" v-on:keyup.enter="getData">
                        <span class="input-group-text">
                        <i class="fa-solid fa-search"></i>
                    </span>
                </div>
                <div class="d-flex align-items-center">
                    <div class="d-block me-3 text-muted">Filter:</div>
                    <div class="d-block me-2" style="width:250px;">
                        <div class="form-select-wrapper">
                            <v-select
                                :options="dataUniversity"
                                label="name"
                                v-model="filter.university"
                                placeholder="Semua Universitas"
                                append-to-body
                                @input='set_university'
                                >
                            </v-select>
                        </div>
                    </div>
                    <div class="d-block me-2" style="width:250px;">
                        <div class="form-select-wrapper">
                            <v-select
                                :options="dataMajor"
                                label="name"
                                v-model="filter.major"
                                placeholder="Semua Jurusan"
                                append-to-body
                                @input='set_major'
                                >
                            </v-select>
                        </div>
                    </div>
                    <div class="d-bloc me-2" style="width:250px;">
                        <select class="form-select form-select-dark" v-model="education_level" v-on:change="getData()">
                            <option value="">Semua Jenjang</option>
                            <option v-for="(item, index) in dataEducationLevel" :key="index" :value="item">{{ item }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="dataFetch" class="container-fluid mt-4">
            <div class="card">
                <div class="card-body">
                    <div class="d-block text-center py-4">
                        <div class="d-block mb-2 text-muted"><i class="fa-solid fa-spin fa-spinner fa-lg"></i></div>
                        <div class="d-block text-sm text-muted ">Loading...</div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!dataFetch && dataList.length > 0" class="card rounded-0 m-0 bg-card-trans-3">
            <div data-simplebar class="table-responsive" style="overflow-y:auto; height:65.9vh;">
                <table class="table table-sm table-hover card-table th-sticky">
                    <thead>
                        <tr>
                            <th class="text-center">No</th>
                            <th>Nama Siswa</th>
                            <th>Universitas</th>
                            <th class="text-center">PM Rapor</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody class="list fs-base">
                        <tr v-for="(item, index) in dataList" :key="index">
                            <td class="text-center">
                                    {{ (index + 1) + (pagination.current_page - 1) * pagination.limit }}
                                </td>
                            <td class="font-bold">
                                <div class="d-flex align-items-center">
                                    <div class="d-block me-3">
                                        <div class="avatar avatar-xs">
                                            <span class="avatar-title rounded-circle bg-white text-dark"><i class="fa-solid fa-user fa-lg m-0"></i></span>
                                        </div>
                                    </div>
                                    <div class="d-block">
                                        <div class="d-block font-bold">{{ item.name }}</div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-block font-bold text-pink">{{ item.university_name }}</div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="d-block small text-muted">Jurusan</div>
                                        <div class="d-block text-sm">{{item.major_name}}</div>
                                    </div>
                                    <div class="col-6">
                                        <div class="d-block small text-muted">Tahun</div>
                                        <div class="d-block text-sm">{{ item.graduation_year }}</div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                <div class="box-score">
                                    <span>{{ item.score_passing_grade }}</span>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <button type="button" class="btn btn-white-naked btn-sm me-2" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Edit" data-bs-original-title="Edit" v-on:click="editData(item.id, item.group)">
                                        <i class="fa-solid fa-pencil"></i>
                                    </button>
                                    <button type="button" class="btn btn-white-naked btn-sm text-danger" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Delete" data-bs-original-title="Delete" v-on:click="deleteData(item.id)">
                                        <i class="fa-solid fa-trash-can"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>                    
                </table>
            </div>

            <div aria-label="navigation" class="card-footer d-flex justify-content-between">

                <!-- Pagination (prev) -->
                <ul class="list-pagination-prev pagination pagination-tabs card-pagination">
                    <li class="page-item">
                        <a class="page-link ps-0 pe-4 border-end border-c-1" :class="pagination.current_page <= 1 ? 'disabled':''" href="javascript:void(0)" v-on:click="pagination_handle('prev')">
                            <i class="fa-solid fa-angle-left me-3"></i>Sebelumnya
                        </a>
                    </li>
                </ul>

                <v-pagination v-model="pagination.current_page" :page-count="pagination.total_pages" :classes="pagination.style" :labels="pagination.anchor_text" v-on:change="getData()"></v-pagination>

                <!-- Pagination (next) -->
                <ul class="list-pagination-next pagination pagination-tabs card-pagination">
                    <li class="page-item">
                        <a class="page-link ps-4 pe-0 border-start border-c-1" :class="pagination.current_page >= pagination.total_pages ? 'disabled':''" href="javascript:void(0)" v-on:click="pagination_handle('next')">
                            Selanjutnya<i class="fa-solid fa-angle-right ms-3"></i>
                        </a>
                    </li>
                </ul>

            </div>            
        </div>

        <div v-if="!dataFetch && emptyState" class="container-fluid mt-4">
            <div class="card">
                <div class="card-body">
                    <div class="d-block text-center py-4">
                        <div class="d-block mb-2 text-pink"><i class="fa-solid fa-triangle-exclamation fa-lg"></i></div>
                        <div class="d-block text-sm text-muted ">Data tidak ditemukan.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vPagination from 'vue-plain-pagination'
export default {
    name: 'SchoolPgAlumni',
    metaInfo: {
        title: 'Jurusan Kaka Kelas',
        titleTemplate: '%s - Rasionalisasi Rapor'
    },
    components: {
        vPagination
    },
    data() {
        return {
            filter : {
                university : [],
                major      : []
            },
            emptyState  : false,
            dataFetch   : false,
            dataList    : [],
            keywords    : "",
            group       : "rapor",
            tabActive   : 'tab_rapor',
            pagination: {
                current_page    : 1,
                total_pages     : 0,
                limit           : 10,
                style: {
                    ul: 'list-pagination pagination pagination-tabs card-pagination',
                    li: 'page-item',
                    a: 'page',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'                
                },
                anchor_text: {
                    first: '',
                    prev: '',
                    next: '',
                    last: ''
                }
            },
            dataUniversity : [],
            university_id : '',
            dataMajor : [],
            major_id : '',
            dataEducationLevel : ['D3','D4','S1'],
            education_level : ''
        }
    },
    created() {        
        this.getUniversity();
        this.getMajor();
        this.changeTab(this.tabActive);
    },
    methods: {
        goToPage: function(type) {
            this.$router.push({ name: 'import_users', params: { type: type } });
        },
        changeTab: function(params="") {
            this.tabActive = params;

            if(this.tabActive == 'tab_rapor') {
                this.group = 'rapor';
            } else {
                this.group = 'utbk';
            }

            this.getData();
        },
        getData: function() {
            let uri         = process.env.VUE_APP_APIHOST+'passing-grade-alumni/list-for-teacher';

            this.dataFetch  = true;                
            this.$http.get(uri,{
                params : {
                    keywords    : this.keywords,
                    page        : this.pagination.current_page,
                    limit       : this.pagination.limit,
                    tab_active  : this.tabActive,
                    group       : this.group,
                    university_id   : this.university_id,
                    major_id   : this.major_id,
                    education_level : this.education_level
                }
            }).then(res => {
                this.emptyState                 = false;
                this.dataFetch                  = false;                
                this.dataList                   = res.data.data;
                this.pagination.total_pages     = res.data.total_page;

                if(this.dataList.length < 1) {
                    this.emptyState = true;
                }
            });
        },
        pagination_handle: function(params) {
            if(params == 'next') {
                if(this.pagination.current_page < this.pagination.total_pages) {
                    this.pagination.current_page = this.pagination.current_page+1;
                    this.getData();
                }
            }

            if(params == 'prev') {
                if(this.pagination.current_page > 1) {
                    this.pagination.current_page = this.pagination.current_page-1;
                    this.getData();
                }
            }
        },
        editData: function(id="", group="") {
            if(group == 'rapor') {
                document.getElementById('btn-close-modal-passing-grade-alumni-detail').click();
                this.$parent.$parent.passing_grade_alumni_form(id)
            } else {
                document.getElementById('btn-close-modal-passing-grade-alumni-utbk-detail').click();
                this.$parent.$parent.passing_grade_alumni_utbk_form(id)
            }
        },
        deleteData: function (id) {
            this.$swal({
                icon: 'info',
                title: 'Hapus Data',
                text: 'Apakah kamu yakin ingin menghapus data ini?',
                confirmButtonText: 'Hapus',
                showCancelButton: true,
                cancelButtonText: 'Batal',
            }).then((result) => {
            if (result.value) {
                this.$http.post(process.env.VUE_APP_APIHOST + 'passing-grade-alumni/delete', {
                    id: id
                })
                .then(response => {
                    if (response.data.status) {
                        this.$swal({
                            icon: 'success',
                            title: 'Success',
                            text: response.data.message,
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.value) {
                                this.getData();
                            }
                        });
                    } else {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: response.data.message,
                    });
                    }
                })
            }
            });
        },
        getUniversity: function() {
            let uri         = process.env.VUE_APP_APIHOST+'university/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataUniversity = res.data.data;
            });
        },
        getMajor: function() {
            this.major_id = "";
            let uri         = process.env.VUE_APP_APIHOST+'master-major/list';
            this.$http.get(uri).then(res => {
                this.dataMajor = res.data.data;
            });
        },
        set_university: function() {
            if (this.filter.university !== undefined && this.filter.university !== null) {
                this.university_id = this.filter.university.id;
            }  else {
                this.university_id = "";
            }
            this.getData();
        },
        set_major: function() {
            if (this.filter.major !== undefined && this.filter.major !== null) {
                this.major_id = this.filter.major.id;
            }  else {
                this.major_id = "";
            }
            this.getData();
        }
    }
}
</script>